export default __webpack_public_path__ + "static/media/delinquency2.a1bee891.png";